import React from "react";
import Image from "next/image";
import clx from "classnames";
import ButtonNoStyles from "../../../common/Buttons/ButtonNoStyles/ButtonNoStyles";
import Typography from "../../../common/Typography/Typography";
import Icon from "../../../common/Icon/Icon";
import { ActionComment } from "../../../../types/Action";
import styles from "./ActionViewComments.module.css";
import formatTimestamp from "../../../../helpers/formatTimestamp";

interface Props {
    comments?: ActionComment[];
    setMobileOpen: React.Dispatch<React.SetStateAction<boolean>>;
    mobileOpen: boolean;
}

const ActionViewCommentsMobileButton = ({ comments, mobileOpen, setMobileOpen }: Props) => {
    const lastComment = comments && comments[comments.length - 1];
    return (
        <ButtonNoStyles
            className="w-full p-1 space-y-1 !bg-slate-200 rounded-md text-left"
            onClick={() => setMobileOpen((state) => !state)}
        >
            <div className="w-full flex justify-between gap-1">
                <Typography as="span" variant="emphasis">
                    Comments <span className={styles.numberOfComments}>{comments ? comments.length : 0}</span>
                </Typography>
                <Icon icon={mobileOpen ? "chevron_down" : "chevron_up"} className="w-1.25 h-1.25" />
            </div>
            {lastComment ? (
                <div className={clx(styles.commentListItem, "border-none space-y-0.5")}>
                    <div className="pb-0.25">
                        <Typography as="p" variant="meta">
                            {lastComment.Note}
                        </Typography>
                    </div>
                    <div className="flex flex-row type-meta text-pine-600">
                        <span>{lastComment.UpdateBy}</span>
                        <Image
                            src="/images/action-commented-by-separator.svg"
                            width={3.5}
                            height={3.5}
                            alt="action author detail separator"
                            className="ml-[7px] mr-[7px]"
                        />
                        <span>{formatTimestamp(lastComment?.CreatedAt as string)}</span>
                    </div>
                </div>
            ) : (
                <p>No comments, click here to be the first to add one.</p>
            )}
        </ButtonNoStyles>
    );
};

export default ActionViewCommentsMobileButton;
